import React from 'react';
import { useHistory } from 'react-router-dom';
import { TableRow, RowContent, Duration, ServiceType, ClientType, StatusContainer, IconWrapper, } from './styles';
import { TicketInfo } from '../TicketInfo/TicketInfo';
import { StatusBadge } from '../StatusBadge/StatusBadge';
import { TicketReminderButton } from '../TicketReminderButton';
import { ROUTES } from 'src/Utils/constants';
export var TicketRow = function (_a) {
    var ticket = _a.ticket, _b = _a.isClientView, isClientView = _b === void 0 ? false : _b;
    var history = useHistory();
    var handleRowClick = function () {
        var route = isClientView
            ? ROUTES.client_ticket_details
            : ROUTES.ticket_details;
        history.push(route.replace(':id', ticket.id.toString()));
    };
    return (React.createElement(TableRow, { "$isHighlighted": ticket.isHighlighted, "$isClientView": isClientView, onClick: handleRowClick },
        React.createElement(RowContent, { "$isClientView": isClientView },
            React.createElement(TicketInfo, { ticket: ticket, isClientView: isClientView }),
            React.createElement(Duration, { "$isClientView": isClientView }, ticket.duration),
            React.createElement(ServiceType, { "$isClientView": isClientView }, ticket.provider_service),
            React.createElement(ClientType, { "$isClientView": isClientView }, ticket.clientType),
            React.createElement(StatusContainer, { "$isClientView": isClientView },
                React.createElement(StatusBadge, { status: ticket.status })),
            !isClientView && (React.createElement(IconWrapper, null,
                React.createElement(TicketReminderButton, { ticketNumber: ticket.ticket_number }))))));
};
